import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
// import DeleteSystemUser from './DeleteSystemUser';
// import AddSystemUser from './AddSystemUser';
// import UpdateSystemUser from './UpdateSystemUser';
import MessageBox from "../../../components/MessageBox/MessageBox";
import ProductPackageView from "./ProductPackageView";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const ProductPackage = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [downloadFlag, setDownloadFlag] = useState(false);
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
		dataFilter();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	//search button
	const dataFilter = async () => {
        	await axios.get(
            process.env.REACT_APP_API_URL+'get_product_package', {
				params:{
					jc_u_idno: get_cookies('branchidno'), //pass the main_nav_id from cookies to get data from api param example: "1,2,3,4,5,6,7,8"
				}
			}).then(function (res) {
				setPosts(res.data.data);
		  	}).catch(function (error) {	
				console.log(error);
	  		});
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const showModal = (message, type) => {
			setShowMsgBox(true);
			setMsgType(type); //success or warning
			setMsg(message);
			dataFilter();
			setTimeout(() => {
				setShowMsgBox(false);
				dataFilter();
			}, 2000)
	};

	const getMuiTheme = () => createTheme({
		overrides: {
		  MUIDataTableHeadCell: {
			root: {
			  '&:nth-child(1)': {
					width: 600
				  },	
			  '&:nth-child(2)': {
				width: 600
			  },
			  '&:nth-child(3)': {
				width: 250
			  },
			}
		  }
		}
	  });

	const columns = [
		{
			name: "id",
			label: "ID",
		},
		{
			name: "description",
			label: "Name",
		},
		{
			name: "user_fullname",
			label:"Actions",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let id = posts[dataIndex].id;
                        
                            return (
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={6} lg={5} xl={4} key={id}>
										   {/* <ProductPackageView id={id}/> */}
                                                                                   <NavLink to={"/settings/product-package-view/"+id}>
                            <Button variant="contained" color="primary">
                            View
                            </Button>	
                        </NavLink> 
                                    </Grid>
                                </Grid>
                            );
			  },
			  download: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: true,
		filterType: "dropdown",
		selectableRows: "none",
		// filterType: "multiselect",
		responsive: "standard",
		download: false,  //add this
		print: false, //add this
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},downloadOptions: {
			filename : 'ProductPackage.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		// marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/settings"}><h4 style={{color:"#339933"}}>Settings</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Product Package</h4>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
						<Grid item xs={12} xl={12} style={{ display: "flex", justifyContent: "flex-end" }}>
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button> */}
							{/* <Button style ={{marginTop: "22px", marginLeft:"10px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Add Role</Button> */}
							
						</Grid>
					</Grid>       
				</div>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Product Package
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
					</MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default ProductPackage;
